import React  from "react";
import { motion } from "framer-motion";
import Container from "../Container/Index";
import Category from "./Categorycard";
import "./Index.css";
import Title from "../Title/Index";
import Client from '../Client/Index';
import Error from '../../Error';
import Swiperslider from "../Swiperslider/Index";
import ImageTag from '../ImageTag/Index'

const ProListing = ({ Data, Data2, homePage, servicePage, listingClass }) => {


  if (!Data || !Data.category || Data.category.length === 0) {
    return <Error />;
  }

  return (
    <Container _parentClass="position-relative serviceSection" containerClass={'float-end'}>
      {servicePage ? (
        <div className="row">
          <Title
            firstHeading={Data.heading}
            secondHeading={Data.title}
            subTitle={Data.descp}
          />
          <div className={`col-12 float-start ${listingClass}`}>
            <div className="col-lg-9 col-sm-10 col-12 m-auto sliderArrowRightBottom">
              <div className="row">
                {Data.category.map((product, index) => (
                  <motion.div
                    className="slides col-12 float-start p-0"
                    key={product.id || index}
                    whileHover={{ scale: 1.01 }}
                  >
                    <Category Data={product} />
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="col-12 float-start productStn p-100">
          <div className="col-lg-11 col-12 m-auto sliderArrowRightBottom bottomPosition">
            <div className="row">
              <Title
                firstHeading={Data.heading}
                secondHeading={Data.title}
                subTitle={Data.descp}
                _spanClass="text-white"
              />
           <Swiperslider slidesPerView={2} smallsliderperview={2} spaceBetween={25} navigation={true} timeDelay={'60000000'} tabspaceBetween={15} loop={false}>
              {Data.category.map((product, index) => (                   
                   <Category Data={product} />
                  ))}
                  </Swiperslider>
            </div>  
          </div>
        </div>
      )}
      {homePage && (
  <div className="col-12 float-start Vision py-lg-5 py-2">
    <Title firstHeading={Data2.heading} _class="mb-4" _spanClass="text-white" />
    <div className="col-lg-10 col-12 m-auto">
      <ul
        data-aos="fade-up"
        data-aos-offset="100"
        data-aos-duration="500"
        data-aos-once="true"
        data-aos-easing="ease-in-sine"
        className="d-lg-flex justify-content-center list-unstyled p-0"
      >
        {Data2.values.map((item, idx) => (
          <li
            key={idx}
            className="d-flex flex-column align-items-center text-center mx-5 mb-4 mb-lg-0"
          >
            <span className="spanIcon mb-3">
              <ImageTag ImagePath={item.iconPath} />
            </span>
            <span dangerouslySetInnerHTML={{ __html: item.title }} />
          </li>
        ))}
      </ul>
    </div>
  </div>
)}

    </Container>
  );
};

export default ProListing;
